export const CLEAR_STORAGE = 'StorageInterface.v1_0.ClearGroupMethod';
export const SET_STORAGE = 'StorageInterface.v1_0.SetValueInGroupMethod';
export const REMOVE_KEY = 'StorageInterface.v1_0.RemoveKeyFromGroupMethod';
export const BATCH_REMOVE_BY_VALUE = 'StorageInterface.v1_0.BatchRemoveByValueFromGroupMethod';
export const BATCH_REMOVE_KEY = 'StorageInterface.v1_0.BatchRemoveKeyFromGroupMethod';
export const BATCH_SET = 'StorageInterface.v1_0.BatchSetValueInGroupMethod';
